import * as _ from "lodash";
import { Components } from "formiojs";
import * as moment from "moment";

const DatagridComponent = Components.components.datagrid;

export default class MiproConsultHistDataGrid extends DatagridComponent {

    static schema() {
        return DatagridComponent.schema({
            type: "miproConsultHistDatagrid",
            label: "Consultation History",
            key: "dbo.mipro.miproConsultHistDatagrid",
            disableAddingRemovingRows: true,
            components: [
                {
                   "label": "Date",
                   "tableView": false,
                   "disabled": true,
                    "datePicker": {
                        "disableWeekends": false,
                        "disableWeekdays": false
                    },

                    "timePicker": {
                        "showMeridian": false
                    },

                    "useLocaleSettings": true,
                    "format": "dd-MM-yyyy HH:mm",

                    "enableMinDateInput": false,
                    "enableMaxDateInput": false,
                    "key": "CHLastUpdatedDate",
                    "type": "datetime",
                    "input": true,
                    "widget": {
                        "type": "calendar",
                        "displayInTimezone": "viewer",
                        "locale": "en",
                        "useLocaleSettings": true,
                        "allowInput": true,
                        "mode": "single",
                        "enableTime": true,
                        "noCalendar": false,
                        "format": "dd-MM-yyyy HH:mm",
                        "hourIncrement": 1,
                        "minuteIncrement": 1,
                        "time_24hr": true,
                        "minDate": null,
                        "disableWeekends": false,
                        "disableWeekdays": false,
                        "maxDate": null
                    }
                },
                {
                  type: "textarea",
                  key: "CHEpisodeName",
                  label: "Episode Name",
                  "disabled": true,
                  input: true
                },
              ]
        });
    }

    init() {
        super.init();
    }

    attach(element) {
        super.attach(element);
        var value = this.getValue();
        if (Array.isArray(value) && value.length > 0) {
            var updatedDateUTC = value[0].CHLastUpdatedDate;

            if (updatedDateUTC) {
                const localDate = moment.utc(updatedDateUTC, "YYYY-MM-DD HH:mm").local().format("YYYY-MM-DD HH:mm");
                value[0].CHLastUpdatedDate = localDate;
                this.setValue(value, {});
            }
        }
    }

    static get builderInfo() {
        return {
            title: "ORB ConsultHistory",
            group: "basic",
            icon: "table",
            weight: 70,
            schema: MiproConsultHistDataGrid.schema(),
        };
    }

}

Components.addComponent("miproConsultHistDatagrid", MiproConsultHistDataGrid);